import React from 'react';
import { IAncillary } from '../../../../domain/ancillary/domain/models/IAncillary';
import { AncillarySummary } from './AncillarySummary';

interface IAncillariesSummaryProps {
	ancillaries: IAncillary[];
}

export const AncillariesSummary = ({
	ancillaries,
}: IAncillariesSummaryProps) => (
	<>
		{ancillaries.map((ancillary) => (
			<AncillarySummary key={ancillary.id} ancillary={ancillary} />
		))}
	</>
);
